import { get, post, put, destroy } from './../Client/BaseClient';

export const PartSpecificationsApi = {
    getPartSpecifications: () =>
        get('PartSpecifications'),
    addPartSpecification: () =>
        post('PartSpecifications'),
    updatePartSpecification: (id) =>
        put(`PartSpecifications/${id}`),
    deletePartSpecification: (id) =>
        destroy(`PartSpecifications/${id}`),
    updatePartSpecification: (id, status) =>
        put(`PartSpecifications/${id}/status/${status}`),
};